import APIAccount from 'api/statistics/account/v1'
import APIAccount2 from 'api/statistics/account/v2'
import omit from 'lodash/omit'
import { call, put, select, takeLatest } from 'redux-saga/effects'
import prepareFilterParams from 'utils/prepareFilterParams'
import { notificationShow } from 'modules/Notifications/actions'
import {
  ACCOUNT_FETCH_CHART,
  ACCOUNT_FETCH_CHART_START,
  ACCOUNT_FETCH_FAIL,
  ACCOUNT_FETCH_TABLE,
  ACCOUNT_FETCH_TABLE_START,
  ACCOUNT_SET_CHART,
  ACCOUNT_SET_TABLE,
  FETCH_ACCOUNT_LOGIN_FAIL,
  FETCH_ACCOUNT_LOGIN_START,
  GET_ACCOUNT_LOGIN,
  SET_ACCOUNT_LOGIN,
} from 'modules/Statistics/types'

function* statisticsFetchChart({ payload }) {
  try {
    const filtersState = yield select((state) => ({
      ...state['statistics/filters'].filters,
      ...state['statistics/account'].filters,
    }))

    const params = omit(prepareFilterParams(filtersState), ['include_vat', 'networks'])

    yield put({
      type: ACCOUNT_FETCH_CHART_START,
      payload: 'chart',
    })

    let METHOD

    switch (payload.network) {
      case 'vk':
      case 'gads':
      case 'vk-ads':
        METHOD = APIAccount.fetchChart
        break
      case 'yd':
        METHOD = APIAccount2.fetchChart
        break
    }

    const { response, error } = yield call(METHOD, {
      params: params,
      ...payload,
    })

    if (error) {
      throw error
    }

    const { items, summary, pagination } = response.data

    yield put({
      type: ACCOUNT_SET_CHART,
      payload: { data: items, summary, pagination },
    })
  } catch (error) {
    yield put({ type: ACCOUNT_FETCH_FAIL, payload: 'chart' })
    yield put(
      notificationShow({
        type: 'error',
        message: 'common::notifications.data_fetch_failed',
      }),
    )
    console.logXHR(error)
  }
}

function* fetchStatisticsAccountLogin({ payload }) {
  try {
    yield put({
      type: FETCH_ACCOUNT_LOGIN_START,
      payload: 'account_login',
    })

    const { response, error } = yield call(APIAccount2.fetchAccountById, {
      ...payload,
    })

    if (error) {
      throw error
    }

    const { login = payload.externalId } = response.data

    yield put({
      type: SET_ACCOUNT_LOGIN,
      payload: { login },
    })
  } catch (error) {
    yield put({
      type: FETCH_ACCOUNT_LOGIN_FAIL,
      payload: 'account_login',
    })
    yield put(
      notificationShow({
        type: 'error',
        message: 'common::notifications.data_fetch_failed',
      }),
    )
    console.logXHR(error)
  }
}

function* fetchStatisticsTable({ payload }) {
  try {
    const { limit, offset, network } = payload
    yield put({
      type: ACCOUNT_FETCH_TABLE_START,
      payload: 'table',
    })

    const filtersState = yield select((state) => ({
      ...state['statistics/filters'].filters,
      ...state['statistics/account'].filters,
    }))

    const params = {
      ...omit(prepareFilterParams(filtersState), ['include_vat', 'networks']),
      limit,
      offset,
    }

    let METHOD

    switch (network) {
      case 'gads':
      case 'vk':
      case 'vk-ads':
        METHOD = APIAccount.fetchAccountCampaigns
        break
      case 'yd':
        METHOD = APIAccount2.fetchAccountCampaigns
        break
    }

    const { response, error } = yield call(METHOD, {
      params: params,
      ...payload,
    })

    if (error) {
      throw error
    }

    const { items, summary, pagination } = response.data

    yield put({
      type: ACCOUNT_SET_TABLE,
      payload: { data: items, summary, pagination },
    })
  } catch (error) {
    yield put({ type: ACCOUNT_FETCH_FAIL, payload: 'table' })
    yield put(
      notificationShow({
        type: 'error',
        message: 'common::notifications.data_fetch_failed',
      }),
    )
    console.logXHR(error)
  }
}

export default function* Sagas() {
  yield takeLatest(ACCOUNT_FETCH_CHART, statisticsFetchChart)
  yield takeLatest(ACCOUNT_FETCH_TABLE, fetchStatisticsTable)
  yield takeLatest(GET_ACCOUNT_LOGIN, fetchStatisticsAccountLogin)
}
